import React from 'react';
import ProjectCard from './ProjectCard';

function ProjectList({ projects, employeeData,onUpdate,onDelete,onUpdateProject }) {
  if (!projects || projects.length === 0) {
    return (
      <div className="text-center text-gray-500">
        <p>No projects to display.</p>
      </div>
    );
  }
console.log(projects)
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {projects.map((project) => (
        <ProjectCard key={project._id} project={project} onDelete={onDelete} employeeData={employeeData} onUpdate={onUpdate} onUpdateProject={onUpdateProject}/>
      ))}
    </div>
  );
}

export default ProjectList;
